/*
 * collection-template-new.js  ·  Oath Jewelry  ·  v1.25.8 (Oct 2026)
 *
 * Controller for the collection filter rail / mobile drawer and toolbar
 * (snippets/oath-collection-products.liquid). Loaded with `defer`.
 *
 * Filter values are native Shopify filter links (full reload), so selection
 * needs no JavaScript. This script handles:
 *   - group collapse/expand (desktop rail and mobile drawer)
 *   - "Show all N" for long value lists
 *   - price presets, min/max apply + clear
 *   - sort change
 *   - mobile drawer open/close (Escape, close buttons, backdrop, focus return)
 *   - collection description "Read more" (all widths)
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function go(url) {
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  ready(function () {
    var root = document.querySelector('[data-oath-filters]');
    var drawerMq = window.matchMedia('(max-width: 749px)');

    if (root) {
      /* ---- Group collapse / expand ---- */
      Array.prototype.forEach.call(root.querySelectorAll('[data-oath-filter]'), function (d) {
        var trigger = d.querySelector('[data-oath-trigger]');
        var panel = d.querySelector('[data-oath-panel]');
        if (!trigger || !panel) return;
        function isOpen() {
          return drawerMq.matches ? !panel.hidden : !d.classList.contains('is-collapsed');
        }
        function sync() { trigger.setAttribute('aria-expanded', isOpen() ? 'true' : 'false'); }
        trigger.addEventListener('click', function () {
          if (drawerMq.matches) {
            panel.hidden = !panel.hidden;
            d.classList.toggle('is-open', !panel.hidden);
          } else {
            d.classList.toggle('is-collapsed');
          }
          sync();
        });
        sync();
        if (drawerMq.addEventListener) drawerMq.addEventListener('change', sync);
      });

      /* ---- Show all N ---- */
      Array.prototype.forEach.call(root.querySelectorAll('[data-oath-more]'), function (b) {
        b.addEventListener('click', function () {
          var f = b.closest('[data-oath-filter]');
          var open = f.classList.toggle('is-expanded');
          b.setAttribute('aria-expanded', open ? 'true' : 'false');
          b.textContent = open ? b.getAttribute('data-label-less') : b.getAttribute('data-label-more');
        });
      });

      /* ---- Price ---- */
      var priceMin = root.querySelector('[data-oath-price-min]');
      var priceMax = root.querySelector('[data-oath-price-max]');
      function setPrice(min, max) {
        var url = new URL(window.location.href);
        if (min !== null && min !== '') url.searchParams.set('filter.v.price.gte', min);
        else url.searchParams.delete('filter.v.price.gte');
        if (max !== null && max !== '') url.searchParams.set('filter.v.price.lte', max);
        else url.searchParams.delete('filter.v.price.lte');
        go(url);
      }
      var apply = root.querySelector('[data-oath-price-apply]');
      if (apply) apply.addEventListener('click', function () {
        setPrice(priceMin ? priceMin.value : null, priceMax ? priceMax.value : null);
      });
      [priceMin, priceMax].forEach(function (inp) {
        if (!inp) return;
        inp.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); setPrice(priceMin.value, priceMax.value); }
        });
      });
      var clear = root.querySelector('[data-oath-price-clear]');
      if (clear) clear.addEventListener('click', function () { setPrice(null, null); });
      Array.prototype.forEach.call(root.querySelectorAll('[data-oath-price-preset]'), function (b) {
        b.addEventListener('click', function () {
          if (b.getAttribute('aria-pressed') === 'true') { setPrice(null, null); return; }
          setPrice(b.getAttribute('data-min'), b.getAttribute('data-max'));
        });
      });

      /* ---- Mobile drawer ---- */
      var opener = document.querySelector('[data-oath-drawer-open]');
      var drawer = root.querySelector('[data-oath-drawer]');
      function openDrawer() {
        root.classList.add('is-open');
        root.setAttribute('role', 'dialog');
        root.setAttribute('aria-modal', 'true');
        root.setAttribute('aria-labelledby', 'oathFilterTitle');
        document.documentElement.classList.add('oath-drawer-lock');
        if (opener) opener.setAttribute('aria-expanded', 'true');
        var first = root.querySelector('.oath-filters__close');
        if (first) first.focus();
      }
      function closeDrawer() {
        if (!root.classList.contains('is-open')) return;
        root.classList.remove('is-open');
        root.removeAttribute('role');
        root.removeAttribute('aria-modal');
        root.removeAttribute('aria-labelledby');
        document.documentElement.classList.remove('oath-drawer-lock');
        if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
      }
      if (opener) opener.addEventListener('click', openDrawer);
      Array.prototype.forEach.call(root.querySelectorAll('[data-oath-drawer-close]'), function (b) {
        b.addEventListener('click', closeDrawer);
      });
      root.addEventListener('click', function (e) { if (e.target === root) closeDrawer(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDrawer();
        if (e.key === 'Tab' && root.classList.contains('is-open') && drawer) {
          var f = drawer.querySelectorAll('a[href]:not([tabindex="-1"]), button:not([disabled]), input, select');
          var vis = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
          if (!vis.length) return;
          var a = vis[0], z = vis[vis.length - 1];
          if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
          else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
        }
      });
      var onMq = function () { if (!drawerMq.matches) closeDrawer(); };
      if (drawerMq.addEventListener) drawerMq.addEventListener('change', onMq);
    }

    /* ---- Sort ---- */
    var sort = document.querySelector('[data-oath-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        if (this.value) url.searchParams.set('sort_by', this.value);
        else url.searchParams.delete('sort_by');
        go(url);
      });
    }

    /* ---- Description "Read more" (all widths; first paragraph clamped to 2 lines) ---- */
    var wrap = document.querySelector('[data-oath-collection-desc]');
    if (wrap) {
      var text = wrap.querySelector('[data-oath-desc-text]');
      var btn = wrap.querySelector('[data-oath-desc-toggle]');
      if (text && btn) {
        var queued = false;
        var evaluate = function () {
          queued = false;
          if (wrap.classList.contains('is-expanded')) return;
          var p = text.querySelector('p');
          var blocks = text.children.length - (text.querySelector('h2') ? 1 : 0);
          var clipped = p && p.scrollHeight > p.clientHeight + 2;
          btn.hidden = !(clipped || blocks > 1);
        };
        var schedule = function () {
          if (queued) return;
          queued = true;
          window.requestAnimationFrame(evaluate);
        };
        btn.addEventListener('click', function () {
          var expanded = wrap.classList.toggle('is-expanded');
          btn.textContent = expanded ? 'Read less' : 'Read more';
          btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });
        schedule();
        window.addEventListener('resize', schedule, { passive: true });
      }
    }
  });
})();
